import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setAllTemplateTableData } from "../../../../../redux/Tracking/actionCreator"
import EditIcon from "../../../../../../src/assets/images/icons/noun-edit-3556018.svg"
import CheckIcon from "@mui/icons-material/Check"
import CloseIcon from "@mui/icons-material/Close"
import CopyIcon from "../../../../../../src/assets/images/icons/copy.svg"
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft"
import { Button, Col, Form, Row, Table } from "react-bootstrap"
import BarLoader from "react-spinners/ClipLoader"
import TemplateEditView from "./style"
import { WysiwygEditor } from "../../../../Reuseable/WysiwygEditor"
import { useFetch } from "../../../../../Hooks/useFetch"
import { api } from "../../../../../Services/api"

const EditTemplate = ({
  item,
  data,
  setTaskview,
  setViewTaskData,
  showEditTask,
  setShowEditTask,
  editPermission,
  updatedData,
  setUpdatedData,
  setHistory,
}) => {
  const dispatch = useDispatch()

  const user = useSelector(state => state.Auth.user)
  const trackingClientId = useSelector(state => state.Auth.user.trackingclientid)
  const { data: allTemplateTableDataRes } = useFetch(
    "get-template",
    `/7_templatelist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false
  )
  let allTemplateTableData = allTemplateTableDataRes?.data ?? []
  const index = allTemplateTableData.findIndex(element => element.templateid === item.templateid)
  const authToken = useSelector(state => state.Auth.authToken)

  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState()
  const [deletedFile, setDeletedFile] = useState([])

  const titleRef = useRef()
  const descriptionRef = useRef()

  const updateTask = (name, value) => {
    setLoading(true)
    let Obj = {
      name: name,
      value: value,
    }
    if (name === "templatetitle")
      setViewTaskData(prevState => {
        return { ...prevState, templatetitle: value }
      })
    if (value) {
      api
        .patch(`/7_templatelist/${trackingClientId}/${item.templateid}`, Obj, {
          headers: {
            authorizationtoken: `${authToken}`,
          },
        })
        .then(function (response) {
          setLoading(false)
          if (response.status === 200) {
            setHistory(response.data.updatedHistory)
            if (index !== -1 || index === 0) {
              allTemplateTableData[index][name] = value
              let newObj = [...allTemplateTableData]
              dispatch(setAllTemplateTableData(newObj))
            }
            if (name === "notes") {
              setViewTaskData(prevState => {
                return { ...prevState, notes: value }
              })
              setShowEditTask(prevState => {
                return { ...prevState, editDescription: false }
              })
            }
          }
        })
        .catch(_error => {})
    }
  }

  const editItem = item => {
    if (item === "templatetitle")
      setShowEditTask(prevState => {
        return { ...prevState, editTitle: true }
      })
    if (item === "notes")
      setShowEditTask(prevState => {
        return { ...prevState, editDescription: true }
      })
  }

  const copyTicketNumber = e => {
    var text = trackingClientId + "-" + item.trackingid
    navigator.clipboard.writeText(text)
    setMsg("Copied")
    setTimeout(() => {
      setMsg("")
    }, 750)
  }

  useEffect(() => {
    if (showEditTask.editTitle) {
      titleRef.current.focus()
    }
    if (showEditTask.editDescription) {
      descriptionRef.current.focusEditor()
    }
  }, [showEditTask])

  const handleSplChar = e => {
    if (e.keyCode === 13) {
      e.preventDefault()
      editItem("templatetitle")
      updateTask("templatetitle", updatedData.templatetitle)
      setShowEditTask(prevState => {
        return { ...prevState, editTitle: false }
      })
    }
    if (
      e.key === "#" ||
      e.key === "$" ||
      e.key === "^" ||
      e.key === "@" ||
      e.key === "*" ||
      e.key === "(" ||
      e.key === "!" ||
      e.key === ")" ||
      e.key === "%" ||
      e.key === "="
    ) {
      e.preventDefault()
    }
  }

  const editIconCSS = {
    marginLeft: "3%",
    cursor: "pointer",
    marginTop: "1%",
  }

  const copyIconCSS = {
    marginLeft: "3%",
    cursor: "pointer",
    marginTop: "2%",
  }

  const tickCloseIconCSS = {
    fontSize: "17px",
    marginTop: "-2px",
    marginLeft: "1%",
  }
  return (
    <>
      <TemplateEditView>
        <h4 className='d-flex justify-content-start align-items-center mb-1'>
          <ArrowCircleLeftIcon
            className='me-3'
            onClick={() => {
              setTaskview("All Templates")
            }}
            style={{ cursor: "pointer", color: "#4EB6EE", fontSize: "30px" }}
          />
          <div className='title add-new-task'>Edit Template</div>
        </h4>
        <div className='taskconatiner p-2'>
          <Table className='trackingviewtable'>
            <tbody className='trackingviewtbody'>
              <div className='trackingviewtbody'>
                <Row>
                  <Col sm={12} md={12} lg={6}>
                    <tr className=''>
                      <td className='border-0 tr-color select-template-options'>
                        <strong>Template ID:</strong>
                      </td>
                      <td className=' border-0  text-capitalize'>
                        <strong className='edit-content tr-color'>
                          {trackingClientId}-{item?.templateid}
                          <img
                            src={CopyIcon}
                            height={15}
                            width={15}
                            style={copyIconCSS}
                            onClick={copyTicketNumber}
                          />
                          <span style={{ marginLeft: "4%", color: "#4EB6EE", fontWeight: "300" }}>
                            {msg}
                          </span>
                        </strong>
                      </td>
                    </tr>
                  </Col>
                  <Col sm={12} md={12} lg={6}></Col>
                  <Col sm={12} md={12} lg={6}>
                    <tr className='tr-color '>
                      <td className='border-0 select-template-options'>Template name:</td>
                      <td className='border-0'>
                        {showEditTask && showEditTask.editTitle ? (
                          <div className='d-flex edit-content trackingdatarow'>
                            <Form.Control
                              type='text'
                              className='p-0 select-options'
                              ref={titleRef}
                              value={updatedData.templatetitle}
                              onChange={e =>
                                setUpdatedData(prevState => {
                                  return { ...prevState, templatetitle: e.target.value }
                                })
                              }
                              onKeyDown={handleSplChar}
                            />
                            <div
                              className='ms-2 text-center edit-cross'
                              onClick={e => {
                                setShowEditTask(prevState => {
                                  return { ...prevState, editTitle: false }
                                })
                                updateTask("templatetitle", updatedData.templatetitle)
                              }}
                            >
                              <CheckIcon style={tickCloseIconCSS} />
                            </div>
                            <div
                              className='ms-2 text-center edit-cross'
                              onClick={e =>
                                setShowEditTask(prevState => {
                                  return { ...prevState, editTitle: false }
                                })
                              }
                            >
                              <CloseIcon style={tickCloseIconCSS} />
                            </div>
                          </div>
                        ) : (
                          <span className='edit-content'>
                            {item?.templatetitle ? updatedData.templatetitle : ""}
                            {editPermission && (
                              <img
                                src={EditIcon}
                                alt='editIcon'
                                height={17}
                                width={17}
                                style={editIconCSS}
                                onClick={e => editItem("templatetitle")}
                              />
                            )}
                          </span>
                        )}
                      </td>
                    </tr>
                  </Col>
                </Row>
              </div>
            </tbody>
          </Table>
          <div className='p-2'>
            <p className='mb-1 ps-3'>
              <strong className='tr-color'> Description: </strong>
            </p>
            {showEditTask && editPermission && showEditTask.editDescription ? (
              <div className='mb-4 editor-section ps-4'>
                <WysiwygEditor
                  editorRef={descriptionRef}
                  handleReturn={(e, des) => {
                    if (e.keyCode === 13) {
                      setShowEditTask(prevState => {
                        return { ...prevState, editDescription: false }
                      })
                      updateTask("notes", des)
                    }
                  }}
                  value={updatedData.notes}
                  onChange={val =>
                    setUpdatedData(prevState => {
                      return { ...prevState, notes: val }
                    })
                  }
                />
                <div className='text-end'>
                  <Button
                    size='sm'
                    sx={{ display: "flex", alignItems: "center" }}
                    variant='secondary'
                    className='titleupdate me-1 ps-3 pe-3 border-none'
                    onClick={e => {
                      updateTask("notes", updatedData.notes)
                    }}
                  >
                    {loading ? (
                      <BarLoader
                        color='#808080'
                        className='bar-loader'
                        size={14}
                        role='status'
                        aria-hidden='true'
                      />
                    ) : (
                      <></>
                    )}
                    <CheckIcon />
                  </Button>
                  <Button
                    size='sm'
                    variant='secondary'
                    className='titlecancel ps-3 pe-3  border-none'
                    onClick={e =>
                      setShowEditTask(prevState => {
                        return { ...prevState, editDescription: false }
                      })
                    }
                  >
                    <CloseIcon />
                  </Button>
                </div>
              </div>
            ) : (
              <Row
                style={{ width: "100%" }}
                onClick={e => editPermission && editItem("notes")}
                className='edit-content description-edit'
                dangerouslySetInnerHTML={{ __html: updatedData?.notes }}
              />
            )}
          </div>
        </div>
      </TemplateEditView>
    </>
  )
}

export default EditTemplate
